import React, { useEffect, useState } from "react";

import moment from "moment";

import { getWeekDays } from "../utils";

import { ReactComponent as ArrowIcon } from "../../../assets/images/environment/arrowIcon.svg";

import "./CalendarSwitcher.css";

export default function CalendarSwitcher({ selectedDate, handleCalendarDateChange }) {
  const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

  useEffect(() => {
    const { startDate, endDate } = getWeekDays(selectedDate);
    const startMoment = moment(new Date(startDate));
    const endMoment = moment(new Date(endDate));
    const sameYear = startMoment.year() === endMoment.year();

    setDateRange({
      startDate: sameYear ? startMoment.format("MMM DD") : startMoment.format("MMM DD YYYY"),
      endDate: sameYear ? endMoment.format("MMM DD") : endMoment.format("MMM DD YYYY"),
    });
  }, [selectedDate]);

  /**
   * Change date
   * @param {"prev" | "next"} type previous/next button
   */
  const onDateChange = (type) => () => {
    const newDate = type === "prev" ? moment(new Date(selectedDate)).subtract(7, "days") : moment(new Date(selectedDate)).add(7, "days");
    handleCalendarDateChange([newDate.toDate()]);
  };

  return (
    <div className="CalendarSwitcher">
      <button type="button" className="CalendarSwitcher__Button" onClick={onDateChange("prev")}>
        <ArrowIcon height={12} width={12} />
      </button>
      <p>
        <span>{dateRange.startDate}</span>
        <span> - </span>
        <span>{dateRange.endDate}</span>
      </p>
      <button type="button" className="CalendarSwitcher__Button rotate-180" onClick={onDateChange("next")}>
        <ArrowIcon height={12} width={12} />
      </button>
    </div>
  );
}
